import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getUserHideEmptyCustomProperties = (
    state: IApplicationState
): boolean => {
    const user = getAuthUser(state);
    return user && user.meta && user.meta.isHideEmptyCustomProperties;
};
